import { render, staticRenderFns } from "./Directs.vue?vue&type=template&id=7fe8c49a&scoped=true"
import script from "./Directs.vue?vue&type=script&lang=js"
export * from "./Directs.vue?vue&type=script&lang=js"
import style0 from "./Directs.vue?vue&type=style&index=0&id=7fe8c49a&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7fe8c49a",
  null
  
)

export default component.exports